/*
 * FLEETA 푸터 — "Consent Preferences" → Termly 동의 설정 모달
 * React Footer.tsx: onClick={() => window.displayPreferenceModal()}
 * Termly 로더는 fleeta-head.liquid에서 head 최상단에 이미 로드됨.
 * 클릭 시점에 함수가 아직 없으면 최대 5초 폴링(로더 지연 대비). document 위임으로
 * 에디터 재렌더에도 안전.
 */
(function () {
  function openPreferenceModal() {
    if (typeof window.displayPreferenceModal === 'function') {
      window.displayPreferenceModal();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-termly-preferences]');
    if (!trigger) return;
    event.preventDefault();

    if (openPreferenceModal()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (openPreferenceModal() || tries >= 50) clearInterval(timer);
    }, 100);
  });

  /*
   * 테마 에디터: 설정 변경 시 섹션이 재렌더되면 새 .ml-form-embed는 비어 있음
   * (MailerLite universal.js는 load 시점에만 스캔). 재스캔 API로 다시 채운다.
   */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target.querySelector('.ml-form-embed')) return;
    if (typeof window.ml === 'function') window.ml('forms', 'embed');
  });
})();
